import { Injectable } from '@angular/core';
import { AgAppConfigService } from '@ag/vc.ag-core/settings';
import { AgTranslateService } from '@ag/vc.ag-core/translate';
import { Observable } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { FactoryhelperService } from './factoryHelper.service';

export type appState = {
  IsInMaintenance: boolean,
  IsStubEnabled: boolean
}
@Injectable({
  providedIn: 'root'
})
export class AppStateService {
  private readonly apiUrl: string;

  constructor(
    private readonly translateService: AgTranslateService,
    private readonly factoryhelperService: FactoryhelperService,
  ) { 
    this.apiUrl = AgAppConfigService.get<string>('applicativeApiUrl');
  }

  fetchAppState(): Observable<appState> {
    const culture = this.translateService.currentLang;
    const url = `${this.apiUrl}/${culture}/silcommon/configuration`;
    return this.factoryhelperService.get<{ Result: appState }>(url).pipe(map(x => x.Result),shareReplay());
  }
}